import z from 'zod';

const AutoCompleteOptionSchema = z.object(
  {
    id: z.number(),
    name: z.string(),
  },
  { message: 'Product category is required' }
);

const productBaseSchema = z.object({
  id: z.number().optional(),
  name: z.string({ message: 'Product name is required' }),
  category: AutoCompleteOptionSchema,
  hash_tag: z
    .array(AutoCompleteOptionSchema, {
      message: 'Product hashtag is required',
    })
    .min(1, { message: 'At least one product hashtag is required' }),
  quantity: z.number({ message: 'Product quantity is required' }),
  price: z.number({ message: 'Product price is required' }),
  description: z.string({ message: 'Product description is required' }),
  save_as: z.enum(['draft', 'published', 'archived']).optional(),
  isDiscounted: z.boolean(),
  discount_amount: z
    .number({ message: 'minimum discount amount is 1%' })
    .optional(),
  discount_starts_at: z.string().optional(),
  discount_ends_at: z.string().optional(),
});

const ExistingImageSchema = z.object({
  id: z.number(),
  file_url: z.string().url(),
  is_default: z.boolean().optional(),
});

export const newProductSchema = productBaseSchema.extend({
  product_images: z
    .array(z.instanceof(File), { message: 'Product image is required' })
    .min(3, { message: 'Please upload at least 3 images' })
    .max(4, { message: 'You can only upload a maximum of 4 images' }),
});

export const editProductSchema = productBaseSchema.extend({
  existing_images: z.array(ExistingImageSchema),
  new_images: z
    .array(z.instanceof(File))
    .max(4, { message: 'You can only upload a maximum of 4 images' })
    .optional(),
});
